import type { AgentContinuation } from '@cdf/api-client-react';
import { Button } from '@/components/ui/button';

interface AgentContinuationCardProps {
  choice: AgentContinuation;
  disabled: boolean;
  onDetails: () => void;
  onScreen: () => void;
  onReview: () => void;
}
export function AgentContinuationCard({ choice, disabled, onDetails, onScreen, onReview }: AgentContinuationCardProps) {
  const retained = Boolean(choice.actionId && choice.revision);
  return (
    <section className="mt-3 space-y-2 rounded-md border bg-background p-3 text-xs" aria-label="Continue this action">
      {choice.explanation && <p>{choice.explanation}</p>}
      {choice.missingInputs.length > 0 && <p>Still needed: {choice.missingInputs.join(', ')}</p>}
      <div className="flex flex-wrap gap-2">
        <Button type="button" variant="outline" size="sm" disabled={disabled || !retained} onClick={onDetails}>Add details in Agent</Button>
        <Button type="button" variant="outline" size="sm" disabled={disabled} onClick={onScreen}>Continue on screen</Button>
        {choice.draftEligible && retained && <Button type="button" size="sm" disabled={disabled || choice.missingInputs.length > 0} onClick={onReview}>Create draft and open</Button>}
      </div>
      <p className="text-muted-foreground">{choice.draftEligible
        ? 'Creating a draft first shows an exact review. Confirm it before anything is saved.'
        : 'The screen keeps its own selection and review steps. Opening it does not execute this action.'}</p>
    </section>
  );
}
